import { useFormikContext } from 'formik';

import { AppointmentRecurring, AppointmentSlotDuration } from '@uplift/api';

export type CreateAppointmentFormValues = {
  isNewPatient: boolean;
  isPsychiatrist: boolean;
  invitedPatient?: {
    firstName: string;
    lastName: string;
    email: string;
  };

  existingPatient?: {
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    preferredName?: string;
  };

  duration?: AppointmentSlotDuration;

  date: string | null;
  startTime: string | null;

  repeats: AppointmentRecurring;
  notes?: string;
};


export const useFormContext = () => {
  const formContext = useFormikContext<CreateAppointmentFormValues>();

  return formContext as Omit<(typeof formContext), 'status'> & {
    status?: {
      errorDisplayed: boolean;
      errorDescription: string;
      submissionBlocked: boolean;
    };
  };
};
